import React from "react";
import Typography from '@mui/material/Typography';
import Connect from "../Connection/Connect";
import AOS from "aos";
import "aos/dist/aos.css";
import './Footer.scss';

const Footer = ({ link }) => {

    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div id="footer" className="text-center">
            <div className="footer-top">
                <div className="container">
                
                    <div 
                        data-aos="zoom-out"
                        data-aos-delay="50"
                        data-aos-duration="900"
                    >
                        <Typography variant="h2" gutterBottom component="div">
                            <span className="initial">A</span>nshika <span className="initial">A</span>grawal
                        </Typography>
                    </div>

                    <Typography variant="subtitle2" gutterBottom component="div" className="sub-heading">
                        Stay Focused 💻
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom component="div" className="mini-heading">
                        Have a Nice Day 😃
                    </Typography>

                    <Connect />
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">
                    <Typography variant="subtitle1" gutterBottom component="div" className="mini-heading">
                        &copy;&nbsp; 
                        {
                            new Date().getFullYear()
                        } 
                        &nbsp;<a href={link} className="back-to-top">Anshika Agrawal</a> All rights reserved.
                    </Typography>
                </div>
            </div>
        </div>
    );
}

export default Footer;